import { Button, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  LoadingOutlined,
  SendOutlined,
} from "@ant-design/icons";
import SignApi from "apis/SignApi";
import { showNotification } from "common";
import moment from "moment";
import { gray } from "@ant-design/colors";
import ServiceApi from "apis/ServiceApi";

export default function ConfirmExtend(props) {
  const {
    base64File,
    setLoading,
    fetchDataDetail,
    setShowFileDk01,
    dataCert,
    dataCheckReq,
  } = props;
// 
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { Text } = Typography;

  const checkSetupPlugin = async () => {
    setLoading(true);
    try {
      const resCheckVersion = await SignApi.checkVersion();
      if (
        resCheckVersion?.status === 200 &&
        resCheckVersion?.data
      ) {
        return true;
      } else {
        showNotification(
          "error",
          "Vui lòng cài đặt hoặc bật phần mềm ký",
          "Thông báo"
        );
        return false;
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error?.message, "Thông báo");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const signPDF = async () => {
    // uploadSignedFile(dataCheckReq.id, base64File);
    setLoading(true);
    try {
      if (await checkSetupPlugin()) {
        const currentDate = moment();
        const formattedDate = currentDate.format("DD-MM-YYYY HH:mm:ss");
        let infoSign = {
          fileData: base64File,
          certSerial: dataCert?.serinumberCert,
          signDate: formattedDate,
          fieldName: "SignatureB [002]",
          typeSign: "1",
          page: "",
          px: "",
          py: "",
          pw: "",
          ph: "",
        };
        const res = await SignApi.signPDF(infoSign);
        if (res && res?.status === 200 && res?.data?.FileDataSigned) {
          uploadSignedFile(dataCheckReq.id, res?.data?.FileDataSigned);
        } else {
          showNotification("error", res?.data?.ErrorDetail, "Thông báo");
        }
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const uploadSignedFile = async (id, data) => {
    setLoading(true);
    try {
      const request = { id, base64: data };
      const res = await ServiceApi.saveDK01Signed(request);
      console.log("res: ", res);
      if (res && res.status === 200) {
        fetchDataDetail();
        // setIsFinish(true);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const onGoBack = () => {
    setShowFileDk01(false);
  };

  return (
    <>
      <Row>
        <Text italic className="note-confirm text-fw-500">
          <Text type="danger">Lưu ý</Text>: Quý khách cần ký file DK-01 để hoàn
          tất yêu cầu gửi gia hạn chứng thư số.
        </Text>
      </Row>
      <Row>
        <Text italic className="text-fw-500">
          Để ký file cần thực hiện các bước sau:
        </Text>
      </Row>
      <Text italic>
        <ol>
          <li>Kiểm tra thông tin file DK-01 dưới đây</li>
          <li>Cắm chữ ký số cần gia hạn</li>
          <li>
            Cài FastCA plugin{" "}
            <a href="https://gen.fastca.vn/tao-lap-chung-thu/downloadPlugin" download>
              Tại đây
            </a>{" "}
            (Nếu đã cài thì bỏ qua bước này)
          </li>
          <li>Nhấn ký xác nhận
          </li>
        </ol>
      </Text>

      {base64File && (
        <Row className="iframe-view-pdf-infochange">
          <iframe
            src={"data:application/pdf;base64," + base64File}
            title="viewPDF"
            className="w--100 hr--38"
            loading="lazy"
            width="100%"
            allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
            allowFullScreen
          ></iframe>
        </Row>
      )}
      <Row justify="center">
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={onGoBack}
            type="primary"
            style={{ background: gray.primary }}
          >
            Quay lại
          </Button>
          <Button icon={<SendOutlined />} type="primary" onClick={signPDF}>
            Ký xác nhận
          </Button>
        </Space>
      </Row>
    </>
  );
}
